export enum UserRole {
  User = 'User',
  Manager = 'Manager',
  Admin = 'Admin'
}

export interface User {
  hasPersonId?: boolean;
  userId: number | null;
  personId: number | null;
  email: string;
  firstName: string | null;
  lastName: string | null;
  isManager: boolean;
  isAdmin: boolean;
  isBlocked: boolean;
}

export const getUserRole = (user: User): UserRole => {
  if (user.isAdmin) return UserRole.Admin;
  if (user.isManager) return UserRole.Manager;
  return UserRole.User;
};

export const getRoleName = (role: UserRole): string => {
  return role;
};

export const getDisplayName = (user: User): string => {
  if (user.firstName && user.lastName) {
    return `${user.firstName} ${user.lastName}`;
  }
  if (user.firstName) {
    return user.firstName;
  }
  if (user.lastName) {
    return user.lastName;
  }
  return user.email;
};

export const hasNoCv = (user: User): boolean => {
  return user.personId === null;
}; 